import { callApi } from "repoV2/utils/common/api/callApi";
import { CALL_API_METHODS } from "repoV2/constants/apis";
import { listing_apis } from "../Listing.constants";
import { IShippingDetailsApiresponse } from "../modules/Merchandise/Merchandise.interfaces";

export const callGetMerchandiseShippingDetails = async ({
    listingUuid,
    currency,
    isInternationalEnabled,
    pinCode,
    variantUuid,
}: {
    listingUuid: string;
    currency: string;
    isInternationalEnabled: boolean;
    pinCode?: string;
    variantUuid?: string;
}): Promise<IShippingDetailsApiresponse> =>
    callApi({
        url: listing_apis.get_shipping_details,
        method: CALL_API_METHODS.GET,
        params: {
            listing_uid: listingUuid,
            currency,
            is_international_enabled: isInternationalEnabled,
            ...(pinCode && {
                client_postcode: pinCode,
            }),
            ...(variantUuid && {
                variation_uid: variantUuid,
            }),
        },
        extraOptions: {
            appendExlyBackendHeaders: true,
        },
    });
